<template>
  <DatatableReportV3
    title="Forms & Checklists Completion"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useStore } from "vuex";

import { Filter } from "@/components/DatatableV3.vue";
import {
  submissionColumns,
  submissionStatusChipComponent
} from "@/CustomForms/formsAndChecklistsColumns";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

withDefaults(
  defineProps<{
    source?: string;
    filters?: Filter[];
  }>(),
  {
    source: "",
    filters: () => []
  }
);

const config = {
  columns: submissionColumns(),
  vueComponents: [submissionStatusChipComponent]
};

const store = useStore();

onMounted(() => {
  store.dispatch("addBreadcrumb", { label: "Forms & Checklists Completion" });
});
</script>
